export default "__VITE_ASSET__q7jd5JnV__"